import React from 'react';
import { Metric } from '@opendate-app/setlist';
import { countChange, formatCount, formatPct, rateChange } from './bookingUtils';

const KPIS = [
  { key: 'holds', label: 'Holds', format: formatCount, change: countChange },
  { key: 'offers', label: 'Offers', format: formatCount, change: countChange },
  { key: 'confirms', label: 'Confirms', format: formatCount, change: countChange },
  { key: 'hold_to_confirm_rate', label: 'Hold → confirm', format: formatPct, change: rateChange },
  { key: 'offer_acceptance_rate', label: 'Offer acceptance', format: formatPct, change: rateChange },
];

const ARROWS = { up: '↑', down: '↓', flat: '→' };

const COMPARISONS = {
  last_year: { key: 'last_year', label: 'vs same period LY' },
  prior: { key: 'prior', label: 'vs prior period' },
};

function BookingKpiCards({ kpis, loading, compareTo, isMobile }) {
  const primary = COMPARISONS[compareTo];
  const secondary = compareTo === 'prior' ? COMPARISONS.last_year : COMPARISONS.prior;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(5, minmax(0, 1fr))', gap: 16, marginBottom: 16 }}>
      {KPIS.map((kpi) => {
        const current = kpis?.[kpi.key];
        const secondaryChange = kpis && kpi.change(current, kpis[secondary.key]?.[kpi.key], secondary.label);
        return (
          <Metric
            key={kpi.key}
            label={kpi.label}
            value={loading || !kpis ? '—' : kpi.format(current)}
            change={kpis ? kpi.change(current, kpis[primary.key]?.[kpi.key], primary.label) : undefined}
            footer={secondaryChange ? (
              <span style={{ fontSize: 12, color: 'var(--sl-text-tertiary)' }}>
                {ARROWS[secondaryChange.direction]} {secondaryChange.value} {secondaryChange.label}
              </span>
            ) : undefined}
          />
        );
      })}
    </div>
  );
}

export default BookingKpiCards;
